import React from "react";
import { Field, ErrorMessage } from "formik";
import { Form } from "react-bootstrap";
import { normalizePostcodeInput } from "../../utils";
import { RequiredFieldMarker } from "../Forms/RequiredFieldMarker";
import {
  buildFieldPath,
  getPrefixedError,
  getPrefixedTouched,
  getPrefixedValue,
} from "./addressFieldPath";

export type AddressFieldName =
  | "addressLine1"
  | "addressLine2"
  | "addressLine3"
  | "town"
  | "county"
  | "postcode"
  | "country";

export interface AddressFieldProps {
  fieldName: AddressFieldName;
  label: string;
  values: any;
  errors: any;
  touched: any;
  handleChange: any;
  fieldPrefix?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
}

export const AddressField: React.FC<AddressFieldProps> = ({
  fieldName,
  label,
  values,
  errors,
  touched,
  handleChange,
  fieldPrefix = "",
  required = false,
  className = "mb-3",
  disabled = false,
}) => {
  const name = buildFieldPath(fieldPrefix, fieldName);
  const value = getPrefixedValue(values, fieldPrefix, fieldName) ?? "";
  const error = getPrefixedError(errors, fieldPrefix, fieldName);
  const fieldTouched = getPrefixedTouched(touched, fieldPrefix, fieldName);
  const invalid = error && fieldTouched;

  const isPostcode = fieldName === "postcode";
  const displayValue = isPostcode ? normalizePostcodeInput(value) : value;

  return (
    <Form.Group className={className} controlId={name}>
      <Form.Label>
        {label}
        {required && <RequiredFieldMarker />}
      </Form.Label>
      <Field
        id={name}
        name={name}
        onChange={
          isPostcode
            ? (e: React.ChangeEvent<HTMLInputElement>) => {
                handleChange({
                  ...e,
                  target: { ...e.target, name, value: normalizePostcodeInput(e.target.value) },
                });
              }
            : handleChange
        }
        type="text"
        value={displayValue}
        className={`form-control${isPostcode ? " text-uppercase" : ""}${invalid ? " is-invalid" : ""}`}
        disabled={disabled}
      />
      <ErrorMessage name={name} component="div" className="invalid-feedback d-block" />
    </Form.Group>
  );
};
